enum BuiltinTags {
  IS_OPEN = "isOpen",
  IS_CLOSE = "isClose",
}
export default BuiltinTags;
